import CARD_REGISTER from '../cards';

// validators
function shouldRenderInFeed(userEvent, cardTemplates, location) {
  if(location !== 'eventFeed') return true;
  return cardTemplates[userEvent.template][userEvent.cardName].showInFeed === '1';
}

function shouldRenderInFlow(userEvent, cardTemplates, location) {
  if(location !== 'flowCard') return true;
  return cardTemplates[userEvent.template][userEvent.cardName].addToParentCard === '1';
}

function shouldRenderInPage(userEvent, cardTemplates, location, activePage) {
  if(location !== 'eventFeed') return true;
  const visibleInPages = (cardTemplates[userEvent.template][userEvent.cardName].visibleInPages || []).map(x => x.toLowerCase());
  const thisPath = activePage.pathname === '/' ? 'home' : activePage.pathname.toLowerCase().replace('/', '');
  return visibleInPages.includes(thisPath);
}

export const eventFeedValidators = {
  hasName: userEvent => !!userEvent.cardName,
  hasTemplate: userEvent => !!userEvent.template,
  hasId: userEvent => !!userEvent.id,
  validState: userEvent => parseInt(userEvent.state, 10) !== 1,
  templateExists: (userEvent, cardTemplates) => !!cardTemplates[userEvent.template],
  cardTypeExists: (userEvent, cardTemplates) => !!cardTemplates[userEvent.template][userEvent.cardName],
  cardInRegister: (userEvent, cardTemplates, cardRegister) => typeof cardRegister[userEvent.template] === 'function',
  shouldRenderInFeed: (userEvent, cardTemplates, cardRegister, location) => shouldRenderInFeed(userEvent, cardTemplates, location),
  shouldRenderInFlow: (userEvent, cardTemplates, cardRegister, location) => shouldRenderInFlow(userEvent, cardTemplates, location),
  shouldRenderInPage: (userEvent, cardTemplates, cardRegister, location, activePage) => shouldRenderInPage(userEvent, cardTemplates, location, activePage),
};

/**  main ui logic determining wether a card should be rendered in its given env.
 *
 * @param { Object } userEvent individual user event from mysofologyapi response
 * @param { Object } cardTemplates templates object parsed from umbraco
 * @param { string } location string representation of rendering context eg: 'eventFeed', 'flowCard'
 * @param { Object } activePage routing object for use with PAGE_LOOKUP
 *
 * @returns { boolean } wether card should be rendered.
 */
export function shouldRenderCard(userEvent, cardTemplates, location = 'eventFeed', activePage) {
  return !!Object.keys(eventFeedValidators)
    .every(test =>
      eventFeedValidators[test](userEvent, cardTemplates, CARD_REGISTER, location, activePage));
}




// WEBPACK FOOTER //
// ./src/services/eventFeedService.js